import React from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../ui/alert-dialog";
import { Button } from "../ui/button";

function ConfirmDialog({
  actionButtonRef,
  open,
  onOpenChange,
  handleConfirm,
  isLoading,
  AlertdialogDescription = "Are you sure you want to proceed? This action cannot be undone.",
}: {
  actionButtonRef?: React.RefObject<() => void>;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  handleConfirm?: () => void;
  isLoading: boolean;
  AlertdialogDescription?: string;
}) {
  const handleClick = () => {
    // Close the dialog immediately to avoid perceived UI freeze
    onOpenChange(false);
    if (actionButtonRef?.current) {
      actionButtonRef.current();
    } else if (handleConfirm) {
      handleConfirm();
    }
  };
  return (
    <AlertDialog
      open={open}
      onOpenChange={(v) => {
        // Toggle inert on app root to prevent focus contention while dialog is open
        const root = document.querySelector("#root, body > div#app, body > div#root") as HTMLElement | null;
        if (root) {
          if (v) root.setAttribute("inert", "");
          else root.removeAttribute("inert");
        }
        onOpenChange(v);
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Confirm Action</AlertDialogTitle>
          <AlertDialogDescription>
            {AlertdialogDescription}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel asChild>
            <Button variant={"outline"}>Cancel</Button>
          </AlertDialogCancel>
          <AlertDialogAction asChild>
            <Button
              onClick={handleClick}
              variant={"destructive"}
              disabled={isLoading}
            >
              Confirm
            </Button>
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

export default ConfirmDialog;
